import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button, Heading } from '@heroui/react';

export function LandingCta() {
  const navigate = useNavigate();

  return (
    <section className="border-t border-separator">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:py-20">
        <div className="flex flex-col items-start gap-6 rounded-2xl bg-accent p-8 text-accent-foreground sm:p-12">
          <Heading level={2} className="max-w-xl text-3xl font-bold tracking-tight">
            Leve o Link Park para o seu condomínio
          </Heading>
          <p className="max-w-xl text-base text-accent-foreground/80">
            Crie a conta, chame o síndico para associar os moradores e comece a disponibilizar
            vagas nesta semana.
          </p>
          <Button
            variant="secondary"
            size="lg"
            className="bg-black text-white"
            onPress={() => navigate('/login')}
          >
            Criar conta grátis
            <ArrowRight size={18} />
          </Button>
        </div>
      </div>
    </section>
  );
}
